/*
 * @Author: xuejian3721
 * @Date: 2024-07-16 15:34:27
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-08-21 09:34:18
 */
import store from '@/store'

// 设置兜底方案样式
export function setBackstopStyle() {
  const backstopObj = store.state.chat.backstopObj || {}
  const content = store.state.mobile ? mobileClassifyStyle(backstopObj) : pcClassifyStyle(backstopObj)
  return content
}

function mobileClassifyStyle({
  imQuestionUnmatchedQuestionDefaultMessageQuestionVOList: backstopList = [],
  tipsWord,
  isShowQuestion
}) {
  let html = ''
  if (isShowQuestion === 1) {
    backstopList.forEach((item, index) => {
      html += `<div style="line-height: 24px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;padding-left: 3px;"
        onclick="replyByQuestion('${item.questionId}')">
        <div style="display: inline-block;font-size: 13px;color: #004B85;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.questionName}</div>
      </div>`
    })
  }
  return `<div class="msg-card-backstop" style="min-width: 170px;box-sizing: border-box;display: flex;flex-direction: column;border-radius: 20px;background: #ffffff;min-height: 102px;}">
    <div style="min-height: 22px; margin: 0 3px; display: flex;flex-direction: column;justify-content: space-between;">
      <div style="width:100%;font-size: 13px;color: #111111;line-height: 18px;">
        ${tipsWord || '亲，可以联系人工客服反馈您遇到的问题，您也可以说下您遇到的问题哦~'}
      </div>
      <div style="width:100%;font-size: 13px;color: #666666;line-height:24px;margin-top: 20px;">猜您可能还想了解</div>
    </div>
    <div style="flex:1;">
    ${html}
    </div>
  </div>`
}

function pcClassifyStyle({
  imQuestionUnmatchedQuestionDefaultMessageQuestionVOList: backstopList = [],
  tipsWord,
  isShowQuestion
}) {
  let html = ''
  if (isShowQuestion === 1) {
    backstopList.forEach((item, index) => {
      html += `<div style="line-height: 37px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;border-bottom: 1px solid #F6F8FA;padding: 0 8px;"
        onclick="replyByQuestion('${item.questionId}')">
        <div style="display: inline-block;font-size: 14px;color: #333333;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.questionName}</div>
        <img style="width:16px;height: 16px;" src="https://s.yyjzt.com/kf-web/20240416/171325412224226e9.png" alt="" />
      </div>`
    })
  }
  return `<div class="msg-card-backstop" style="min-width: 324px;box-sizing: border-box;display: flex;flex-direction: column;border-radius: 20px;background: #F6F6F6;min-height: 102px;}">
    <div style="min-height: 44px; margin: 12px 12px; display: flex;flex-direction: column;justify-content: space-between;">
      <div style="width:100%;font-weight: 700;font-size: 14px;color: #333333;line-height: 18px;">
        ${tipsWord || '亲，可以联系人工客服反馈您遇到的问题，您也可以说下您遇到的问题哦~'}
      </div>
      <div style="width:100%;font-size: 14px;color: #666666;line-height: 18px;">猜你可能还想问</div>
    </div>
    <div style="flex:1; margin: 0 12px 12px;background-color: #fff;border-radius: 8px;">
    ${html}
    </div>
  </div>`
}
